import { IdentityAvatar } from './IdentityAvatar';

export interface HeroAvatarGroupItem {
  id: string;
  name: string;
  avatarUrl?: string | null;
}

/** Participant stack using the same photo-or-monogram identity as the conversation. */
export function HeroAvatarGroup({
  users,
  max = 3,
  size = 'sm',
}: {
  users: HeroAvatarGroupItem[];
  max?: number;
  size?: 'sm' | 'md' | 'lg';
}) {
  const shown = users.slice(0, max);
  const extra = users.length - shown.length;

  return (
    <div className="flex -space-x-1">
      {shown.map((u) => (
        <IdentityAvatar key={u.id} id={u.id} name={u.name} src={u.avatarUrl} size={size} />
      ))}
      {extra > 0 && (
        <span className={`studio-avatar studio-avatar-${size} text-xs`}>+{extra}</span>
      )}
    </div>
  );
}
